import { createLinkPlugin, withLink } from '@udecode/plate'
import { withCompose } from '~ui-components/components/molecules/TextEditor/utilities/withCompose'

export default () =>
  createLinkPlugin({
    withOverrides: withCompose(withLink)
  })
